import React, { FC, useState, useEffect } from 'react';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';

import SearchIcon from '@mui/icons-material/Search';
import SingleFilter from './SingleFilter';

interface ListPageFilterBarProps {
  afterClear: () => void;
  filterDefinitions: any;
  controller: string;
  filterValues: any;
  fetchRecordsList: any;
  setFilterValues: any;
  searchQuery: any;
  setSearchQuery: any;
  queryPlaceholder: any;
  includeQuerySearch?: boolean;
}

const ListPageFilterBar: FC<ListPageFilterBarProps> = (props) => {
  let {
    afterClear,
    filterDefinitions,
    controller,
    filterValues,
    fetchRecordsList,
    setFilterValues,
    searchQuery,
    setSearchQuery,
    queryPlaceholder,
    includeQuerySearch = true,
  } = props;

  const [localQuery, setLocalQuery] = useState<string>('');

  useEffect(() => {
    setLocalQuery(searchQuery);
  }, [searchQuery]);

  const handleQueryEntered = (value) => {
    setSearchQuery(value);
    fetchRecordsList(controller, filterValues, 1, value, '');
  };

  return (
    <Grid container alignItems="center" spacing={2}>
      {includeQuerySearch && (
        <Grid item xs={12} md={3}>
          <TextField
            placeholder={queryPlaceholder}
            value={localQuery}
            onChange={(e) => setLocalQuery(e.target.value)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleQueryEntered(localQuery);
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ fontSize: 22 }} />
                </InputAdornment>
              ),
              style: { padding: '6px 10px' },
            }}
            inputProps={{
              style: {
                fontSize: 14,
                padding: 6,
              },
            }}
            style={{ width: '100%' }}
          />
        </Grid>
      )}
      {filterDefinitions?.map((filter, index) => (
        <Grid key={filter?.param || filter?.label || `filter-${index}`} item xs={12} md={filter.width || 2}>
          <SingleFilter
            filter={filter}
            controller={controller}
            fetchRecordsList={fetchRecordsList}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
            searchQuery={searchQuery}
          />
        </Grid>
      ))}
      <Grid item alignItems="center" style={{ marginTop: -5 }}>
        <Button variant="contained" color="inherit" onClick={afterClear}>
          Clear Filters
        </Button>
      </Grid>
    </Grid>
  );
};

export default ListPageFilterBar;
